import { render, staticRenderFns } from "./savings-pay.vue?vue&type=template&id=304bfd46&scoped=true"
import script from "./savings-pay.vue?vue&type=script&lang=js"
export * from "./savings-pay.vue?vue&type=script&lang=js"
import style0 from "./savings-pay.vue?vue&type=style&index=0&id=304bfd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304bfd46",
  null
  
)

export default component.exports